import { createClient } from '@/shared/api';
import CALL_CENTER_ACTIVE_TIME_TRACKING_MUTATION from '@/entities/facility/api/mutations/callCenterActiveTimeTracking';
import type {
  CallCenterActiveTimeTrackingMutation,
  CallCenterActiveTimeTrackingMutationVariables,
} from '@/shared/api/generated/graphql';

export type CallCenterActiveTimeTrackingResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the CallCenterActiveTimeTrackingInput GraphQL input once its server-side shape is documented
/**
 * Reports a call-center user's active time to the server. Runs the active time tracking mutation and throws the server message when it does not report success.
 *
 * @param input - Mutation input carrying the tracked active interval.
 * @returns A promise resolving once the active-time sample has been accepted.
 */
const handleCallCenterActiveTimeTracking = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<
    CallCenterActiveTimeTrackingMutation,
    CallCenterActiveTimeTrackingMutationVariables
  >({
    mutation: CALL_CENTER_ACTIVE_TIME_TRACKING_MUTATION,
    variables: {
      input,
    },
  });
  if (!result?.data?.callCenterActiveTimeTracking?.isSuccess) {
    throw new Error(result?.data?.callCenterActiveTimeTracking?.message);
  }
};

export default handleCallCenterActiveTimeTracking;
